(function () {
  function panels(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function showPanel(list, id) {
    list.forEach(function (panel) {
      panel.hidden = panel.id !== id;
    });
  }

  function markCurrent(list, current) {
    list.forEach(function (item) {
      var on = item === current;
      item.classList.toggle('is-active', on);
      if (item.getAttribute('aria-current') === 'page') return;
      if (on) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  }

  function revealPill(pill) {
    var scroller = pill.parentElement;
    if (!scroller) return;
    var target = pill.offsetLeft - 12;
    scroller.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
  }

  function isContactLabel(link) {
    return (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() === 'contact us';
  }

  function absorbContactHref(root) {
    var contact = root.querySelector('[data-browse-contact]');
    var menu = root.closest('.main-menu__content');
    if (!contact || !menu) return;
    var extras = menu.querySelectorAll('.mob__announcement-links a, .secondary-nav a');
    Array.prototype.forEach.call(extras, function (link) {
      if (link === contact || !isContactLabel(link)) return;
      if (link.getAttribute('href')) contact.setAttribute('href', link.getAttribute('href'));
    });
  }

  function closeDrawer(root) {
    var menu = root.closest('main-menu');
    if (!menu) return;
    var toggle = menu.querySelector('.main-menu__toggle');
    var content = menu.querySelector('.main-menu__content');
    if (toggle && content && content.classList.contains('is-open')) toggle.click();
  }

  function init(root) {
    if (!root || root.getAttribute('data-browse-bound') === 'true') return;
    root.setAttribute('data-browse-bound', 'true');

    var l1Panels = panels(root, '[data-browse-panel]');

    function activateL1(button) {
      markCurrent(panels(root, '[data-browse-l1]'), button);
      showPanel(l1Panels, button.getAttribute('aria-controls'));
    }

    function activateL2(button) {
      var l1 = button.closest('[data-browse-panel]');
      if (!l1) return;
      markCurrent(panels(l1, '[data-browse-l2]'), button);
      showPanel(panels(l1, '[data-browse-l2-panel]'), button.getAttribute('aria-controls'));
      revealPill(button);
    }

    absorbContactHref(root);
    var menuContent = root.closest('.main-menu__content');
    if (menuContent && window.MutationObserver) {
      var contactObserver = new MutationObserver(function () { absorbContactHref(root); });
      contactObserver.observe(menuContent, { childList: true, subtree: true });
    }

    root.addEventListener('click', function (event) {
      var l1 = event.target.closest('[data-browse-l1]');
      if (l1 && root.contains(l1)) {
        activateL1(l1);
        return;
      }

      var l2 = event.target.closest('[data-browse-l2]');
      if (l2 && root.contains(l2)) {
        activateL2(l2);
        return;
      }

      var link = event.target.closest('a');
      if (!link || !root.contains(link)) return;
      var href = link.getAttribute('href') || '';
      if (!href || href === '#') return;
      closeDrawer(root);
    });

    root.addEventListener('keydown', function (event) {
      var rail = event.target.closest('[data-browse-rail]');
      if (rail && root.contains(rail) && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        var rails = panels(root, '[data-browse-rail]');
        var railIndex = rails.indexOf(rail);
        var railNext = event.key === 'ArrowDown' ? rails[railIndex + 1] : rails[railIndex - 1];
        if (!railNext) return;
        event.preventDefault();
        railNext.focus();
        if (railNext.hasAttribute('data-browse-l1')) activateL1(railNext);
        return;
      }

      var pill = event.target.closest('[data-browse-l2]');
      if (pill && root.contains(pill) && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
        var l1Panel = pill.closest('[data-browse-panel]');
        var pills = panels(l1Panel, '[data-browse-l2]');
        var pillIndex = pills.indexOf(pill);
        var pillNext = event.key === 'ArrowRight' ? pills[pillIndex + 1] : pills[pillIndex - 1];
        if (!pillNext) return;
        event.preventDefault();
        pillNext.focus();
        activateL2(pillNext);
      }
    });

    var menu = root.closest('main-menu');
    if (!menu) return;
    menu.addEventListener('click', function (event) {
      var toggle = event.target.closest('.main-menu__toggle');
      if (!toggle || !menu.contains(toggle)) return;
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      var current = root.querySelector('[data-browse-l1].is-active');
      if (current) current.focus();
    });
  }

  function boot(scope) {
    var context = scope || document;
    var nodes = context.querySelectorAll('[data-mobile-browse]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
